module.exports = __webpack_public_path__ + "img/64.17e2df9b.jpg";